import { INDUSTRY } from '@helper/const';

const INDUSTRY_PREFIX = 'industry-';

function getIndustryBodyClassName(industry) {
  return `${INDUSTRY_PREFIX}${industry}`;
}

function setIndustryToBody(industry) {
  const industryName = getIndustryBodyClassName(industry);
  document.body.className = `${document.body.className} ${industryName}`;
}

function getIndustryFromBody() {
  const cn = document.body.className || '';
  const cnAry = cn.split(' ');
  let res = INDUSTRY.NORMAL;
  cnAry.forEach(item => {
    const idx = item.indexOf(INDUSTRY_PREFIX);
    if (idx !== -1) {
      res = item.substr(idx + INDUSTRY_PREFIX.length);
      return res;
    }
  });
  return res;
}

export { getIndustryBodyClassName, setIndustryToBody, getIndustryFromBody };



// WEBPACK FOOTER //
// ./src/helper/industry-helper.js